import { render, staticRenderFns } from "./horizontal-topbar.vue?vue&type=template&id=4bd6388b&"
import script from "./horizontal-topbar.vue?vue&type=script&lang=js&"
export * from "./horizontal-topbar.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-topbar.vue?vue&type=style&index=0&id=4bd6388b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports